import React from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

const ListMenuButton = ({
   active,
   activeBackgroundColor,
   activeTextColor,
   borderRadius,
   borderStyle,
   height,
   icon,
   linkExact,
   linkIsExternal,
   linkTo,
   name,
   paddingHorizontal,
   pinned,
   showBadge,
   showPlaceholderIcon,
   textColor,
   textFontFamily,
   textFontWeight,
   textLetterSpacing,
   textSize,
   textTransform
}) => {
   // Button may be set as active directly
   // (ie. in the case of notes where we need to highlight 2 nights)
   // or automatically via NavLink component
   const activeButtonStyle = css`
      background-color: ${activeBackgroundColor};
      color: ${activeTextColor} !important;
      bottom: 1px;
      left: -${paddingHorizontal};
      padding: 0px ${paddingHorizontal} !important;
      width: calc(100% + ${paddingHorizontal}) !important;
      font-weight: ${textFontWeight} !important;
      border-radius: ${borderRadius};

      .line { display: none; }
   `

   const Button = linkIsExternal ? 'a' : NavLink
   const buttonProps = linkIsExternal
      ? { href: linkTo, target: '_blank', rel: 'noopener noreferrer' }
      : { to: linkTo, exact: linkExact, activeClassName: activeButtonStyle }

   return (
      <Button
         className={css`
            position: relative;
            display: inline-flex;
            align-items: center;
            width: 100%;
            color: ${textColor};
            padding: 0 ${paddingHorizontal} 1px 0;
            letter-spacing: ${textLetterSpacing};
            line-height: 120%;
            font-family: ${textFontFamily};
            font-size: ${textSize};
            text-transform: ${textTransform};

            ${active && activeButtonStyle}
         `}
         {...buttonProps}>
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            height={height}>
            <View
               className="line"
               position="absolute"
               borderTop={borderStyle}
               bottom="0px"
               left="0px"
               right={borderRadius}
            />
            <View display="flex" alignItems="center" width={showBadge ? '85%' : '95%'}>
               {icon && (
                  <View
                     display="flex"
                     alignItems="center"
                     flex="0 0 auto"
                     width="30px"
                     paddingRight="15px">
                     {icon}
                  </View>
               )}
               {showPlaceholderIcon && (
                  <View
                     display="flex"
                     alignItems="center"
                     flex="0 0 auto"
                     width="16px"
                     height="16px"
                     border={`1px solid ${textColor}`}
                     borderRadius="4px"
                     marginRight="15px"
                     opacity="0.2"
                  />
               )}
               <Text
                  letterSpacing={textLetterSpacing}
                  lineHeight="120%"
                  fontFamily={textFontFamily}
                  size={textSize}
                  transform={textTransform}
                  weight="inherit"
                  color="inherit"
                  style={{
                     width: '100%',
                     whiteSpace: 'nowrap',
                     overflow: 'hidden',
                     textOverflow: 'ellipsis'
                  }}>
                  {name}
                  {pinned && '(Pinned)'}
               </Text>
            </View>
            {showBadge && (
               <View
                  margin="2px 10px 0px 10px"
                  width="6px"
                  height="6px"
                  backgroundColor="orange"
                  borderRadius="50%"
               />
            )}
         </View>
      </Button>
   )
}

ListMenuButton.propTypes = {
   active: PropTypes.bool,
   activeBackgroundColor: PropTypes.string,
   activeTextColor: PropTypes.string,
   borderRadius: PropTypes.string,
   borderStyle: PropTypes.string,
   height: PropTypes.string,
   icon: PropTypes.node,
   linkExact: PropTypes.bool,
   linkIsExternal: PropTypes.bool,
   linkTo: PropTypes.string,
   name: PropTypes.string.isRequired,
   paddingHorizontal: PropTypes.string,
   pinned: PropTypes.bool,
   showBadge: PropTypes.bool,
   showPlaceholderIcon: PropTypes.bool,
   textColor: PropTypes.string,
   textFontFamily: PropTypes.string,
   textFontWeight: PropTypes.string,
   textLetterSpacing: PropTypes.string,
   textSize: PropTypes.string,
   textTransform: PropTypes.string
}

ListMenuButton.defaultProps = {
   active: false,
   activeBackgroundColor: '#000',
   activeTextColor: '#fff',
   borderRadius: '4px',
   borderStyle: undefined,
   height: '40px',
   icon: undefined,
   linkExact: false,
   linkIsExternal: false,
   linkTo: undefined,
   paddingHorizontal: '10px',
   pinned: false,
   showBadge: false,
   showPlaceholderIcon: false,
   textColor: '#555',
   textFontFamily: undefined,
   textFontWeight: 'normal',
   textLetterSpacing: undefined,
   textSize: '2',
   textTransform: 'none'
}

export default ListMenuButton
